import { useEffect, useRef, useState } from "react";
import { useAuthUser } from "react-auth-kit";
import { useServerApi } from "./userServerApi";
import {
  getCachedUserRoleAccess,
  loadUserRoleAccess,
  subscribeUserRoleAccess,
} from "../helpers/userRoleAccessCache";

export const useLiveUserRole = () => {
  const auth = useAuthUser();
  const [api] = useServerApi();
  const authRole = auth()?.userRole;
  const roleId = authRole?._id;
  const fetchRoleRef = useRef(api.getById);
  fetchRoleRef.current = api.getById;

  const [liveRole, setLiveRole] = useState(
    () => getCachedUserRoleAccess(roleId) || authRole
  );

  useEffect(() => {
    return subscribeUserRoleAccess((payload) => {
      if (payload?.role) {
        setLiveRole(payload.role);
        return;
      }
      if (payload?.invalidated && roleId) {
        loadUserRoleAccess(
          roleId,
          (id) => fetchRoleRef.current({ apiEntity: "userRole", id }),
          { force: true }
        );
      }
    });
  }, [roleId]);

  useEffect(() => {
    if (!roleId) {
      setLiveRole(authRole);
      return;
    }
    setLiveRole((current) => getCachedUserRoleAccess(roleId) || current || authRole);
    loadUserRoleAccess(roleId, (id) =>
      fetchRoleRef.current({ apiEntity: "userRole", id })
    );
  }, [roleId]);

  return liveRole || authRole;
};
